// extracted by mini-css-extract-plugin
export default {"collapse-control":"collapse-control-6409","expanded":"expanded-b469","content":"content-d480","show":"show-c4da","flow-card":"flow-card-b6f9","disabled":"disabled-a5ec"};